import * as S from './styled';

function Row ({ children }) {
  return <S.Container>
    {children}
  </S.Container>;
}

export default Row;
